export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00775.d3496b30.png";